/**
 * useLogoutConfirm — logica di logout condivisa tra tutti gli entry-point
 * dell'app gestionale (logo sidebar, logo topbar mobile, UserMenuDropdown).
 *
 * Pattern: stato locale per-istanza (confirmOpen) che apre il dialog di
 * conferma; confirmLogout chiama signOut(auth) + navigate('/login').
 * Non tocca useAuth né il singleton; è una pura estrazione meccanica degli
 * handler già presenti in AppSidebar e UserMenuDropdown.
 */

import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../security/firebase';

export interface UseLogoutConfirmResult {
  confirmOpen: boolean;
  triggerLogout: () => void;
  confirmLogout: () => Promise<void>;
  cancelLogout: () => void;
}

export function useLogoutConfirm(): UseLogoutConfirmResult {
  const navigate = useNavigate();
  const [confirmOpen, setConfirmOpen] = useState(false);

  const triggerLogout = useCallback(() => {
    setConfirmOpen(true);
  }, []);

  const confirmLogout = useCallback(async () => {
    setConfirmOpen(false);
    try {
      await signOut(auth);
    } finally {
      navigate('/login', { replace: true });
    }
  }, [navigate]);

  const cancelLogout = useCallback(() => {
    setConfirmOpen(false);
  }, []);

  return { confirmOpen, triggerLogout, confirmLogout, cancelLogout };
}
